import React from 'react'
import { Row } from 'antd'
import { useTranslation } from 'next-i18next'
import { useAppDispatch, useAppSelector } from 'src/app/hooks'
import { CustomCol, FormLabels, CustomInputDecimal, CustomText, CustomCheckBox } from 'src/components'
import {
  isFreeDonationSelectedSelector,
  setProjectFormItemValue,
  projectDetailsSelector,
  projectFormStateSelector,
} from 'src/features'

const ProjectFormTonsAvailable: React.FC = () => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const { is_vintage, kind } = useAppSelector(projectFormStateSelector)
  const isFreeDonationSelected = useAppSelector(isFreeDonationSelectedSelector)
  const { project: projectToEdit } = useAppSelector(projectDetailsSelector)

  const tonfield = {
    compensation: { label: t('Projects.TonCo2Label'), unit: 'tCO₂' },
    energy: { label: t('Projects.AvailableMWh'), unit: 'MWh' },
    contribution: { label: t('Projects.TotalContribution'), unit: 'UD' },
    biodiversity: { label: t('Projects.CreditStock'), unit: 'CR' },
    carbon_forward: { label: t('Projects.TonCo2Label'), unit: 'tCO₂' },
  }[kind]

  return <Row className='mb-4'>
    <CustomCol>
      <FormLabels
        title={tonfield.label}
        subtitle={t('Projects.StockLabel')}
        thirdLabel={kind === 'biodiversity' && t('Projects.CreditSubLabel')}
      />
    </CustomCol>
    <CustomCol>
      {(!isFreeDonationSelected && !is_vintage) && (
        <CustomInputDecimal
          required
          name='volume_credits'
          placeholder={t('Projects.StockPlaceHolder')}
          addonAfter={<CustomText label={tonfield.unit} type='secondary' />}
          onChange={(value: number) => {
            dispatch(setProjectFormItemValue({ key: 'volume_credits', value }))
          }}
        />
      )}

      {!['contribution', 'biodiversity'].includes(kind) && (
        <CustomCheckBox
          isSmallText
          defaultValue={is_vintage}
          disabled={projectToEdit?.is_vintage || kind === 'carbon_forward'}
          text={t('Projects.VintagePlaceholder')}
          handleChange={(value) => {
            if (!projectToEdit) { dispatch(setProjectFormItemValue({ key: 'discounts', value: [] })) }
            dispatch(setProjectFormItemValue({ key: 'is_vintage', value }))
          }}
        />
      )}
    </CustomCol>
  </Row>
}

export default ProjectFormTonsAvailable
